/**
 * 配置编译环境和线上环境之间的切换
 * 
 * host: 域名地址
 * urlPerfix: 接口地址
 * uploadAliyunOss: 是否上传到阿里云OSS
 * uploadFileFormat: 上传文件类型
 * 
 */

let host = 'http://localhost:8080/a'
if (process.env.NODE_ENV == 'production') {
    host = 'https://vts.leybold.cn/a'
}
let urlPerfix = host + "/api/v1"
let urlPerfixV2 = host + "/api/v2"

let uploadLimitSize = { //单位M
    image: 10,
    file: 50,
}
let thumbnailImagePath = ""
let originImagePath = ""

let app = {
    name: process.env.VUE_APP_NAME,
    logo_main: process.env.VUE_APP_LOGO_MAIN,
    logo_sub: process.env.VUE_APP_LOGO_SUB,
    favicon: process.env.VUE_APP_FAVICON
}

export {
    host,
    app,
    urlPerfix,
    urlPerfixV2,
    thumbnailImagePath,
    originImagePath,
    uploadLimitSize,
}